export enum LockedPageKeys {
    Employment = 'employment_locks',
    Compensation = 'compensation_locks',
    Enrollments = 'enrollment_locks',
    Ghl = 'ghl_locks',

}

export interface LockedPageState {
    isLocked: boolean;
    generalMessage?: string;
    lockedSummaries?: string[];
}

export interface LocksModel {
    [key: string]: string[];
}